import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnExperimentUrl } from './paths';
import type { AbnSuccessResponse, UpdateAbnExperimentStatusParams } from './types';

export async function updateAbnExperimentStatus(instanceName: string, params: UpdateAbnExperimentStatusParams) {
  /* eslint-disable camelcase */
  const body = {
    experiment_name: params.experimentName,
    action: params.action,
  };
  /* eslint-enable camelcase */

  const response = await api.executePostRequest<ObjectResponse<AbnSuccessResponse>>(
    `${abnExperimentUrl(instanceName, params.experimentId)}/status`,
    body
  );

  return response.data;
}
